import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

export interface AddDepartmentSaveRequest {
  name: 'string';
}

const useAddDepartmentApi = (companyId: number) => {
  const call = useCallback(
    async (body?: any[]) => {
      try {
        const res = await axiosInstance.put(api.addDepartment(companyId), body);
        return res.data;
      } catch (error) {
        throw error;
      }
    },
    [companyId]
  );
  const { isLoading, execute } = useAsync(call, false, undefined);

  return {
    isLoading,
    addNewDepartment: execute,
  };
};
export default useAddDepartmentApi;
